import { Component, input } from '@angular/core';
import { CdnStatus } from '@shared/models/site';
import { NgClass } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-activation-cdn-label',
  template: `
    @if (cdnStatus() === 'ACTIVE' || !cdnStatus()) {
      <span class="label cdn" [title]="'CDN.status.' + cdnStatus() | translate" [ngClass]="cdnStatus()">CDN</span>
    }

    @if (cdnStatus() === 'ACTIVATION_IN_PROGRESS' || cdnStatus() === 'SYNC_IN_PROGRESS') {
      <span class="label cdn" [title]="'CDN.status.' + cdnStatus() | translate" [ngClass]="cdnStatus()">
        <span [title]="'CDN.status.' + cdnStatus() | translate" class="spinner"></span>CDN</span
      >
    }
  `,
  styles: `
    .label.cdn {
      background-color: transparent;
      color: black;
      border: 1px solid #2ecc71;
      padding: 5px 6px 3px 6px;

      .spinner {
        position: relative;
        display: inline-block;
        overflow-y: visible;
        padding-left: 15px;
      }

      .spinner:before {
        position: absolute;
        top: -11px;
        left: -2px;
        content: '\\f0e0';
        font-family: IcoFont !important;
        font-size: 130%;
        display: inline-block;
        margin-right: 0.8ex;
        animation: anim-rotate 1s infinite steps(8);
      }

      &.cdnActivationInProgress,
      &.ACTIVATION_IN_PROGRESS {
        border-color: #f39c12;
      }
    }
  `,
  imports: [NgClass, TranslatePipe],
})
export class ActivationCdnLabelComponent {
  public cdnStatus = input<CdnStatus>();
}
